import React from "react";
import Cookies from 'js-cookie'
import history from '../../history';
import ProfileAPI from "../Apis/ProfileAPI";

export const getAccessToken = () => Cookies.get('access_token')
export const getRefreshToken = () => Cookies.get('refresh_token')
export const isAuthenticated = () => !!getAccessToken();

export const authenticate = async (username, password, redirectPath) => {
    if(isAuthenticated()) { return;};
    try {
        const tokens = getRefreshToken() ?  await fetchRefreshToken(getRefreshToken()) : await fetchAuthToken();
        saveTokens(tokens, username);
        history.push(redirectPath || '/home'); 
        history.go();
    } catch (error) {
        redirectToLogin()
        return false
    }
}
export const loggedUser = () => {
    if(isAuthenticated() && Cookies.get('user')) {
        return ProfileAPI.getUser(Cookies.get('user'));
    }
    return;
}
export const logout = async (e) => {
    e.preventDefault();
    try {
        Cookies.remove('access_token');
        Cookies.remove('refresh_token');
        history.push('/');
    } catch (error) {
        history.push('/logout')
        return false
    }
    history.go();
}
const saveTokens = (tokens, username) => {
    const expires = (tokens.expires_in || 60 * 60) * 1000
    const inOneHour = new Date(new Date().getTime() + expires)

    Cookies.set('access_token', tokens.access_token, { expires: inOneHour })
    Cookies.set('user', username, { expires: inOneHour });
    Cookies.set('refresh_token', tokens.refresh_token);

    return true
}
const redirectToLogin = () => {
    history.push('/login') // if your Login page is inside the same app
}
const fetchRefreshToken = (refreshToken) => {
    return {access_token: '###', refresh_token: '###'}
    // call an API, returns tokens
}
const fetchAuthToken = (username, password) => {
    // call an API, returns tokens
    return {access_token: '###', refresh_token: '###'}
}

function createMarkup(content) {
    return { __html: content };
}

export const getPaginatedResult = (page, data = [], limit = 10) => {
        const pages = parseInt(data.length / limit) + (data.length % limit > 0 ? 1 : 0);
        if (page) {
            var startAt = (page - 1) * limit;
            return {
                data: data.slice(startAt, startAt + limit),
                pages: pages
            };
        }
        return {
            data: data,
            pages: pages
        };
}

export const randomID = () => {
    var S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4());
}

export const redirectPage = (page) => {
    history.push(page);
    history.go();
}

export const toClassName = (str) => { return str?.toLowerCase().replaceAll(" ", '-').replaceAll("/", "-"); }

export const toHTML = (content) => {
    return <div dangerouslySetInnerHTML={createMarkup(content)} />
}
export const toList = (elements, component, callBack) => {
    return elements && elements.map(function (itemData, i) {
        if (callBack) return callBack(itemData, i);
        const props = typeof itemData === 'string' ? {} : itemData;
        return React.createElement(component, {
            ...props,
            key: i
        }, itemData?.child || itemData);
    });
};

export default toList;